export const DATA_TABLE_SECTION = 'data-table';
export const CHART_SECTION = 'chart';
export const CDN_SECTION = 'cdn';
export const FILTER_SECTION = 'filter';
export const SUMMARY_SECTION = 'summary';
export const ONETIME_DATA_SECTION = 'onetime_data';
export const CUSTOM_TEXT_SECTION = 'custom_text_section';
